/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a UUID or ULID to validate it and read its details — version, variant, and any embedded timestamp — decoded instantly in your browser. It handles UUID versions 1 through 8, the special nil and max values, and Crockford base32 ULIDs.`)
};

const es_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega un UUID o ULID para validarlo y leer sus detalles — versión, variante, y cualquier marca de tiempo incorporada — decodificada al instante en tu navegador. Maneja versiones de UUID 1 a 8, los valores especiales nil y max, y ULIDs en base32 de Crockford.`)
};

const de_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine UUID oder ULID ein, um sie zu validieren und ihre Details abzulesen — Version, Variante und jeden eingebetteten Zeitstempel — sofort decodiert in Ihrem Browser. Es unterstützt die UUID-Versionen 1 bis 8, die speziellen nil- und max-Werte sowie Crockford-base32-ULIDs.`)
};

const nl_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een UUID of ULID om deze te valideren en lees de details — versie, variant en eventuele ingebouwde tijdstempel — direct in je browser gedecodeerd. Het verwerkt UUID-versies 1 tot en met 8, de speciale waarden nil en max, en Crockford base32 ULID's.`)
};

const fr_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez un UUID ou un ULID pour le valider et lire ses détails — version, variante, et tout horodatage intégré — décodé instantanément dans votre navigateur. Il gère les versions d'UUID 1 à 8, les valeurs spéciales nil et max, et les ULID en base32 Crockford.`)
};

const it_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un UUID o un ULID per convalidarlo e leggerne i dettagli — versione, variante, e qualsiasi timestamp incorporato — decodificato istantaneamente nel tuo browser. Gestisce le versioni UUID da 1 a 8, i valori speciali nil e max, e gli ULID Crockford base32.`)
};

const pt_br2_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um UUID ou ULID para validá-lo e ler seus detalhes — versão, variante, e qualquer timestamp incorporado — decodificado instantaneamente no seu navegador. Ele trata versões de UUID 1 a 8, os valores especiais nil e max, e ULIDs em base32 de Crockford.`)
};

const pt_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole um UUID ou ULID para o validar e ler os seus detalhes — versão, variante e qualquer timestamp incorporado — descodificado instantaneamente no seu navegador. Funciona com versões 1 a 8 de UUID, os valores nil e max especiais e ULIDs em Crockford base32.`)
};

const ja_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UUID または ULID を貼り付けて検証し、その詳細を読み取ります — バージョン、バリアント、および埋め込みタイムスタンプ — ブラウザでインスタントにデコードされます。UUID バージョン 1 から 8、特別な nil 値と max 値、および Crockford base32 ULID を処理します。`)
};

const zh_home_seo_ud_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一个 UUID 或 ULID 以验证它并查看其详细信息——版本、变体以及任何内嵌的时间戳——在你的浏览器中即时解码。它支持 UUID 版本 1 到 8、特殊的 nil 和 max 值,以及 Crockford base32 编码的 ULID。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_ud_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_ud_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_ud_p1", locale)
	if (locale === "en") return en_home_seo_ud_p1(inputs)
	if (locale === "es") return es_home_seo_ud_p1(inputs)
	if (locale === "de") return de_home_seo_ud_p1(inputs)
	if (locale === "nl") return nl_home_seo_ud_p1(inputs)
	if (locale === "fr") return fr_home_seo_ud_p1(inputs)
	if (locale === "it") return it_home_seo_ud_p1(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_ud_p1(inputs)
	if (locale === "pt") return pt_home_seo_ud_p1(inputs)
	if (locale === "ja") return ja_home_seo_ud_p1(inputs)
	return zh_home_seo_ud_p1(inputs)
};